import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '~/styles/extended-theme.ts';

const inputVariants = cva(
  cn(
    'flex h-10 w-full border-input bg-background py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium font-light',
    'placeholder:text-primary-light',
    'hover:border-b-2',
    'focus-visible:outline-none focus-visible:border-double focus-visible:border-b-4',
    'disabled:cursor-not-allowed disabled:opacity-50 read-only:cursor-not-allowed read-only:opacity-50',
  ),
  {
    variants: {
      variant: {
        default: 'border-b px-0',
        rounded: 'rounded-full border px-3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {
  asChild?: boolean;
  hasError?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, hasError, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          inputVariants({ variant, className }),
          hasError ? 'border-b-2 border-secondary' : null,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
